import React from 'react';
import {Footer} from 'app/components/sign/form/static/footer';
import {Translate} from "app/services/translate";

export const LoginFooter = () => {
    const termsUrl = Translate('signing_terms_url');
    const privacyPolicyUrl = Translate('signing_privacy_policy_url');

    const acceptTermsText = Translate('signing_login_register_incentive')
        .replace('%terms_url%', `"${termsUrl}"`)
        .replace('%privacy_policy_url%', `"${privacyPolicyUrl}"`);

    return (
        <Footer>
            <p dangerouslySetInnerHTML={{__html: acceptTermsText}}/>
            <a href={Translate('signing_register_url')}>
                {Translate('signing_login_register_register')}
            </a>
        </Footer>
    );
};